module.exports = __webpack_public_path__ + "static/media/12.d111f48a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/unused icon/12.svg
// module id = 417
// module chunks = 14